<template>
  <div class="w-full mb-2">
    <div
      class="pt-4 pr-4 pl-4 tablet:pb-10 mobile:pb-28 relative rounded-2xl border border-gray-500 shadow-sm mobile:!bg-transparent tablet:bg-white laptop:!bg-[#ffffff94] min-h-[500px]">
      <div class="absolute -top-[25px] right-5 flex items-center gap-3">
        <!-- Share Plan -->
        <div @click="shareModal()"
          class="group hover:!bg-purple-100 hover:text-white transition-all cursor-pointer mobile:hidden tablet:flex items-center gap-3 rounded-full tablet:py-3 tablet:px-4 w-max shadow-[0px_0px_10px_0px_#00000026;] text-black-100 bg-white">
          <img src="../../assets/images/Share-icon.png" alt="Share Icon"
            class="mobile:w-5 mobile:h-5 tablet:w-7 tablet:h-7 filter mobile:invert mobile:brightness-0 tablet:invert-[unset] tablet:brightness-[unset] tablet:group-hover:invert tablet:group-hover:brightness-0">
          <p class="mb-0 text-[18px] font-normal">Share</p>
        </div>
        <!-- cart btn  -->
        <div  v-if="(cartCountResponse?.checkout_type ?? 'internal') != 'internal'" @click="cartModal()"
          class=" cursor-pointer flex items-center gap-2 rounded-full mobile:p-1 tablet:py-2 tablet:px-3 w-max shadow-[0px_0px_10px_0px_#00000026;] bg-white"
          :class="{ 'cursor-not-allowed': cartCount == null || (cartCount && cartCount.items_count == 0) }">
          <div
            class="flex items-center gap-2 rounded-full mobile:px-2 mobile:py-0.5 tablet:px-3 tablet:py-1 w-max bg-cyan-400"
            :class="{ '!bg-[#ccc]': cartCount == null || (cartCount && cartCount.items_count == 0) }">
            <img src="../../assets/images/cart-check-white.png" alt="Cart Icon"
              class="mobile:w-5 mobile:h-5 tablet:w-7 tablet:h-7">
            <span class="mobile:text-lg tablet:text-xl font-roboto font-bold text-white">{{ cartCount ?
              cartCount.items_count : 0 }}</span>
          </div>
          <span class="font-roboto font-bold mobile:text-lg tablet:text-2xl text-black-100"
            :class="{ '!text-[#ccc]': cartCount == null || (cartCount && cartCount.items_count == 0) }">${{ cartCount ?
              $helper.formatAmount(cartCount?.total_amount ?? 0) : '0' }}</span>
        </div>
      </div>
      <!-- Share Plan mobilebtn -->
      <div @click="shareModal()"
        class="group hover:!bg-purple-100 hover:text-white transition-all absolute bottom-[50px] translate-x-[50%] right-[50%] cursor-pointer mobile:flex tablet:hidden items-center gap-3 rounded-full p-2 px-4 w-max shadow-[0px_0px_10px_0px_#00000026;] text-white bg-purple-100 ">
        <img src="../../assets/images/Share-icon.png" alt="Share Icon"
          class="mobile:w-5 mobile:h-5 tablet:w-7 tablet:h-7 filter mobile:invert mobile:brightness-0 tablet:invert-[unset] tablet:brightness-[unset] tablet:group-hover:invert tablet:group-hover:brightness-0">
        <p class="mb-0 text-[18px] font-normal">Share</p>
      </div>
      <div>
        <customSlider :length="plans.length">
          <Slide v-for="(plan, index) in plans" :key="index">
            <bundleCard v-if="plan.is_single_plan_bundle != 1" :plan="plan" :updateCart="updateCart"
              :updateCard="updateCard">
              <template #action>
                <a class="cursor-pointer py-1.5 px-3 mobile:text-sm tablet:text-base rounded-full border-[1px] no-underline !border-purple-100 text-purple-100 hover:bg-purple-100 hover:text-white"
                  @click="planModal(plan)">
                  View Details
                </a>
              </template>
            </bundleCard>
            <protectionPlanCard v-else :plan="plan.plans[0]" :updateCart="updateCart" :updateCard="updateCard">
              <template #action>
                <a class="cursor-pointer py-1.5 px-3 mobile:text-sm tablet:text-base rounded-full border-[1px] no-underline !border-purple-100 text-purple-100 hover:bg-purple-100 hover:text-white"
                  @click="planModal(plan.plans[0])">
                  View Details
                </a>
              </template>
            </protectionPlanCard>

          </Slide>


        </customSlider>
      </div>
      <div v-if="!isLoading && plans?.length <= 0">
        <h6 class="text-center m-0 text-gray-400">
          No Bundles Available
        </h6>
      </div>

      <div  v-if="(cartCountResponse?.checkout_type ?? 'internal') != 'internal'"
        class="absolute bottom-0 tablet:right-0 mobile:translate-x-[50%] mobile:right-[50%] w-full tablet:-translate-x-5 translate-y-5 flex mobile:justify-center tablet:justify-end">
               <button @click="nrgModal(false)" :disabled="cartCount == null || (cartCount && cartCount.items_count == 0)"
          class="px-3 py-1.5 mt-4 flex justify-end items-center gap-1 text-base rounded-full bg-[#FC819E] text-white hover:!shadow-md disabled:bg-[#EFEFEF] disabled:!text-gray-500 disabled:cursor-not-allowed">
          <span class=" ">{{ cartCountResponse?.checkout_button_title ?? "Go to Enroll" }}</span>
          <img src="../../assets/images/arrow-icon.png" class="w-7 h-7 object-contain" :class="{
            'invert brightness-50': cartCount == null || (cartCount && cartCount.items_count == 0)
          }" alt="icon">
        </button>
      </div>

    </div>

    <div v-if="!isLoading" class="mt-16 border-t border-[#CCCCCC]">
      <disclaimer />
    </div>
  </div>

  <!-- Bundle Detail Modal -->
  <bundleDetailModal ref="protectionCarDetailtRef" @event="updateCart" :isCartUpdate="isCartUpdate" />

  <!-- Protection Plan Detail Modal -->
  <div class="modal fade" id="bundlePlanDetailModal" ref="bundlePlanDetailModal" tabindex="-1"
    aria-labelledby="bundlePlanDetailModal" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div
      class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:!w-[500px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
      <div class="modal-content select-none">
        <div class="modal-body !p-3 !pb-5" v-if="protectionPlanDetails">
          <div class="relative">
            <button type="button" class="absolute top-3 right-4 w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
              data-bs-dismiss="modal" aria-label="Close">
              <font-awesome-icon icon="times" class="w-full h-full text-red-600" />
            </button>
            <div class="relative rounded-lg overflow-hidden h-[100px]">
              <img src="../../assets/images/profile-bg.png" alt="Background"
                class="w-full mobile:h-full tablet:h-auto object-cover">
              <div class="flex flex-col justify-center gap-1 p-3 absolute top-0 left-0 w-full h-full">
                <div class="flex justify-start items-center gap-1">
                  <div class="w-1.5 h-1.5 rounded-full bg-purple-100"></div>
                  <div class="w-6 h-1.5 rounded-full bg-purple-100"></div>
                  <p class=" text-lg font-bold font-roboto pl-2 m-0 text-fuchsia-700">New Plan</p>
                </div>
                <h4 class="mobile:text-lg table:text-xl m-0 text-black-100">{{
                  protectionPlanDetails.plan_name }}</h4>
              </div>
            </div>
          </div>
          <div
            class="responsiveOreitationHeightAdjust mobile:max-h-[50vh] mobile:mt-8 tablet:mt-5 tablet:max-h-[70vh] desktop:max-h-[50vh] largeDesktop:max-h-[70vh] pr-2 mb-3 overflow-y-auto customScrollbar">
            <protectionPlanDetailCard :plan="protectionPlanDetails" />
          </div>
          <div class="py-3">
            <span v-if="protectionPlanDetails.quantity == null || protectionPlanDetails.quantity == 0"
              @click="updateCounter('increment')"
              class="w-max group px-3 py-1.5 flex justify-center items-center mx-auto gap-1 text-base rounded-full cursor-pointer border-[1px] !border-secondary-100 text-secondary-100 hover:bg-secondary-100 hover:text-white">
              <img src="../../assets/images/cart-check.png" class="w-7 h-7 object-contain group-hover:hidden"
                alt="icon">
              <img src="../../assets/images/cart-check-white.png"
                class="w-7 h-7 object-contain !hidden group-hover:!block" alt="icon">
              Select this plan
            </span>
            <div v-else class="flex w-full justify-center items-center gap-4">
              <quantityCounter v-if="protectionPlanDetails.is_show_quantity == 1"
                :quantity="protectionPlanDetails.quantity" @update-counter="updateCounter" />
              <button v-else type="button" @click="updateCounter('remove')"
                class="group h-10 w-10 flex items-center justify-center rounded-full focus:outline-0 transition-all border-1 border-[#F67280] hover:bg-[#F67280]">
                <img src="../../assets/images/trash-icon-updated.png" alt="Cart Icon"
                  class="w-7 h-7 group-hover:hidden">
                <img src="../../assets/images/trash-icon-white-updated.png" alt="Cart Icon"
                  class="w-7 h-7 hidden group-hover:!block">
              </button>
              <span type="button"
                class="group h-10 w-10 flex items-center justify-center rounded-full focus:outline-0 transition-all border-1 bg-secondary-100 text-white">
                <img src="../../assets/images/cart-check-white.png" alt="Cart Icon" class="w-7 h-7">
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Cart Modal -->
  <protectionCartModal ref="protectionCartRef" @event="updateCart" :isCartUpdate="isCartUpdate" />

  <!-- NRG Modal -->
  <div class="modal fade" id="NRGModal" ref="NRGModal" tabindex="-1" aria-labelledby="NRGModal" aria-hidden="true">
    <div
      class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:!w-[500px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
      <div class="modal-content select-none">
        <div class="modal-body !p-3 !pb-5">
          <div class="relative">
            <div class="relative rounded-lg overflow-hidden mobile:h-[70px] tablet:h-[100px]">
              <img src="../../assets/images/profile-bg.png" alt="Background" class="w-full h-auto object-cover">
              <div class="flex items-center gap-1 p-3 absolute top-0 left-0 w-full h-full">
                <h4
                  class="mobile:text-lg tablet:text-xl tablet:pr-10 mobile:pr-0 m-0 font-roboto font-bold text-gray-800">
                  You're
                  Being Redirected to Complete Your
                  Purchase</h4>
              </div>
            </div>
          </div>
          <div class="responsiveOreitationNRGHeightAdjust max-h-[80vh] overflow-y-auto customScrollbar mt-3">
            <p class="text-base font-roboto text-gray-950">Thank you for using FYXIFY! You are now being redirected to
              the
              NRG Protects Inc environment to complete your purchase
              of the protection plan you selected. Please follow the instructions there to finalize your order.</p>
            <p class="text-base font-roboto text-gray-950">If you need assistance at any point, feel free to contact our
              support team. We appreciate your business
              and are here to help!</p>
            <button @click="nextClicked"
              class="px-4 py-1.5 mt-4 flex justify-center items-center mx-auto gap-1 text-base rounded-lg bg-[#00B7C2]">
              <span class="text-white">Next</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- share Modal -->
  <sharePlanModal ref="openSharePlanModal" />


  <!-- planalreadypurchasedmodal -->
  <div class="modal fade !z-[1060]" id="planalreadypurchasedmodal" ref="planalreadypurchasedmodal" tabindex="-1"
    aria-labelledby="planalreadypurchasedmodal" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!px-3 laptop:!w-[500px] !mx-auto !m-0 h-full">
      <div class="modal-content font-roboto">
        <div class="modal-body !p-3 !pb-5">
          <div class="relative">
            <button type="button" class="absolute top-3 right-4 w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
              aria-label="Close" @click="planalreadypurchasedHide()">
              <font-awesome-icon icon="times" class="w-full h-full text-red-400" />
            </button>
            <div class="relative rounded-lg overflow-hidden mobile:h-[70px] tablet:h-[80px]">
              <img src="../../assets/images/profile-bg.png" alt="Background" class="w-full h-auto object-cover">
              <div class="flex items-center gap-1 p-3 absolute top-0 left-0 w-full h-full">
                <h4 class="mx-auto text-xl m-0 font-roboto font-medium text-red-400">
                  Plan Already Purchased
                </h4>
              </div>
            </div>
            <div>
              <div class="mobile:py-1 tablet:py-2.5 px-2">
                <div class="mobile:py-1.5 tablet:py-3">
                  <p class="text-base font-normal mb-4">Only one plan per service category can be purchased for a single
                    address.</p>
                  <p class="text-base font-normal mb-0">The following plans are already active at:</p>
                  <span class="text-[#9336B4] text-[18px] font-bold leading-[1]">{{ consumerBindCartResponse?.address
                    }}</span>
                  <div class="mobile:py-1.5 tablet:py-3">
                    <div class="max-h-[200px] overflow-y-auto customScrollbar">
                      <div v-for="(plan, index) in consumerBindCartResponse?.plans" :key="index"
                        class="py-1 flex items-start justify-start gap-3">
                        <img src="@/assets/images/check-double-purple.png" alt="Icon"
                          class="img-fluid h-6 w-6 object-contain">
                        <div>
                          <p class="text-base font-bold text-black mb-0">{{ plan.category }}</p>
                          <p class="text-base font-normal mb-0 text-[#666666]">{{ plan.name }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p class="text-base font-normal mb-0 text-center">To proceed, please either select a <span
                      class="text-red-400">different address</span> or <span class="text-red-400">remove the conflicting
                      plan(s)</span> from your cart.</p>
                </div>
                <div class="flex justify-center items-center mobile:pt-2 tablet:pt-4">
                  <button type="button" @click="planalreadypurchasedHide()"
                    class="text-sm w-[96px] h-[38px] flex justify-center items-center rounded-lg !border text-white bg-red-400">Dismiss</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <createQoute ref="createQuoteRef" :submitClicked="submitClicked" />
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Modal } from "bootstrap";
import 'vue3-carousel/dist/carousel.css';
import { Slide } from 'vue3-carousel';
import customSlider from '../../components/partialComponent/customSlider.vue';
import bundleCard from "../../components/protectionPlansCards/bundleCard.vue";
import createQoute from "../../components/createQuote/createQuote.vue";
import { useToast } from "vue-toastification";
const toast = useToast();
import disclaimer from "../../components/protectionPlansCards/disclaimer.vue";
import protectionCartModal from "../../components/protectionPlansCards/protectionCartModal.vue";
import bundleDetailModal from "../../components/protectionPlansCards/bundleDetailModal.vue";
import sharePlanModal from "../../components/protectionPlansCards/sharePlanModal.vue";
import protectionPlanCard from "../../components/protectionPlansCards/protectionPlansCard.vue";
import protectionPlanDetailCard from '../../components/protectionPlansCards/protectionPlanDetailCard.vue';
import quantityCounter from '../../components/partialComponent/quantityCounter.vue';

import { globals } from "../../main";

export default {
  components: {
    bundleCard,
    customSlider,
    Slide,
    createQoute,
    disclaimer,
    protectionCartModal,
    bundleDetailModal,
    sharePlanModal,
    protectionPlanCard,
    protectionPlanDetailCard,
    quantityCounter
  },
  data() {
    return {
      isOpenFromCart: false,
      isCartUpdate: false,
      plans: [],
      cartCount: {},
      updateCard: null,
      updateCardCart: null,
      isLoading: true,
      protectionPlanDetails: { plans: [] },
      selectedPlan: {},
      selectedType: 'bundle',
      isFromNRGModal: false,
    };
  },

  computed: {
    ...mapGetters([
      "protectionPlanBundle",
      "cartCountResponse",
      "cartDetails",
      "cartUpdated",
      "consumerBindCartResponse",
      "cartCheckoutResponse",
      "cartValidate",
      "removeProtectionCartData",
      "selectedProtectionPlan",
      "protectionPlanBundleDetailsCallBack"
    ]),

    cartItemsTotal() {

      let total = 0

      if (this.cartDetails?.items?.length > 0) {
        total = this.cartDetails.items.reduce((sum, item) => sum + parseFloat(item.item_total_amount), 0);
      }

      return total
    },

    modalCartCount() {
      let totalQuantity = !this.$helper.isEmpty(this.cartDetails.items) ? this.cartDetails.items.reduce((sum, item) => sum + item.item_quantity, 0) : 0
      return totalQuantity
    }
  },

  watch: {

    selectedProtectionPlan: function (data) {

      this.getBundleData()

    },

    protectionPlanBundleDetailsCallBack: function (data) {

      if (this.protectionPlanBundleDetailsCallBack.is_single_plan_bundle == 1) {
        this.protectionPlanDetails = this.protectionPlanBundleDetailsCallBack.plans[0]
        const { Modal } = require('bootstrap');
        const modalEl = this.$refs.bundlePlanDetailModal;

        this.modal = Modal.getInstance(modalEl);
        if (!this.modal) {
          this.modal = new Modal(modalEl, {
            backdrop: 'static',
            keyboard: false
          });
        }
        // Add event listeners for show/hide
        modalEl.addEventListener('show.bs.modal', () => {
          document.documentElement.style.overflow = 'hidden'; // Target HTML element
          if (window.innerWidth >= 992) {
            document.documentElement.style.paddingRight = '15px';
          } else {
            document.documentElement.style.paddingRight = '0px';
          }
          this.adjustPlanModalHeight();
        });

        modalEl.addEventListener('hidden.bs.modal', () => {
          document.documentElement.style.overflow = ''; // Reset HTML element
          document.documentElement.style.paddingRight = '0px';
          window.removeEventListener('resize', this.adjustPlanModalHeight);
          window.removeEventListener('orientationchange', this.adjustPlanModalHeight);
        });

        window.addEventListener('resize', this.adjustPlanModalHeight);
        window.addEventListener('orientationchange', this.adjustPlanModalHeight);
        this.modal.show();
        this.$refs.bundlePlanDetailModal.addEventListener('hidden.bs.modal', this.onCartModalClose);


      }
      else {
        // this.$refs.protectionCarDetailtRef.openCartModal(this.protectionPlanBundleDetailsCallBack)
      }
    },

    removeProtectionCartData: function (data) {

      if (this.selectedType == 'bundle') {
        this.upsertCart({
          "bundle_id": this.selectedPlan.id,
          "quantity": this.selectedPlan.quantity,
          "partner_id": this.selectedPlan.partner_id? this.selectedPlan.partner_id : this.selectedProtectionPlan.partner_id
        })
      }
      else {
        this.upsertCart({
          "plan_id": this.selectedPlan.id,
          "quantity": this.selectedPlan.quantity,
          "partner_id": this.selectedPlan.partner_id? this.selectedPlan.partner_id : this.selectedProtectionPlan.partner_id
        })
      }

    },
    cartValidate: function (data) {

      if (this.cartValidate.validation_passed) {

        if (this.selectedType == 'bundle') {
          this.upsertCart({
            "bundle_id": this.selectedPlan.id,
            "quantity": this.selectedPlan.quantity,
            "partner_id": this.selectedPlan.partner_id? this.selectedPlan.partner_id : this.selectedProtectionPlan.partner_id
          })
        }
        else {
          this.upsertCart({
            "plan_id": this.selectedPlan.id,
            "quantity": this.selectedPlan.quantity,
            "partner_id": this.selectedPlan.partner_id? this.selectedPlan.partner_id : this.selectedProtectionPlan.partner_id
          })
        }

      }
      else {

        this.$confirmDialog.show({
          title: "Action Required",
          message: this.cartValidate.message,

          onConfirm: () => {
            this.removeBundle(this.cartValidate)
          },
        });
      }

    },

    protectionPlanBundle: function (data) {
      this.plans = data
      this.isLoading = false
      // this.plans = this.protectionPlans.Plumbing?? []
      // this.plans = this.protectionPlans.Electric?? []
      if (localStorage.getItem('user') ?? null != null) {
        // /  this.getCartCount({})
      }

    },

    cartCountResponse: function (data) {
      this.cartCount = this.cartCountResponse
      if (this.isFromNRGModal) {
        this.isFromNRGModal = false
        if (this.cartCountResponse?.items_count ?? 0 > 0) {
          this.cartCheckout({})
        } else {
          if (this.modal) {
            this.modal.hide();
          }
          this.modal = null
          this.$confirmDialog.show({
            buttonText: "Refresh",
            title: "Your Cart is Empty",
            message: "Your cart has been cleared after completing checkout on another device or session. Please add new items to your cart in order to continue. Click refresh to update your cart view.",
            onConfirm: () => {
              globals.$loader.show();
              window.location = window.location.href
            },
          });
        }
      } else if (this.isOpenFromCart && (this.cartModal == null || (this.cartCount && this.cartCount.items_count > 0))) {
        this.isOpenFromCart = false
        this.$refs.createQuoteRef.showModal();
      }
    },

    cartUpdated: function (data) {
      //  this.getProtectionPlans({});
      if (this.isCartUpdate) {
        this.updateCardCart = new Date()
        this.getCartDetails({})
        //  this.getDetails()
      } else {
        //   this.updateCard = new Date()
        this.getCartCount({})
        this.getBundleData();
        this.getCartDetails({})
        //   this.getDetails()
        if (this.protectionPlanDetails) {
          this.protectionPlanDetails.quantity = this.selectedPlan?.quantity ?? 1
        }
      }

    },

    consumerBindCartResponse: function (data) {

      if (this.consumerBindCartResponse.business_rule_failure == '1') {
        const modalEl = this.$refs.planalreadypurchasedmodal;
        const modal = new Modal(modalEl);
        document.documentElement.style.overflow = 'hidden';
        modal.show();
      } else {
        this.$refs.createQuoteRef.hideModal();
        this.$refs.protectionCartRef.hideModal();
        setTimeout(() => {
          document.documentElement.style.overflow = 'hidden';
          this.openNRGModel()
        }, 500);
      }
    },

    cartCheckoutResponse: function (data) {
      this.modal.hide();
      this.modal = null
      window.location.href = this.cartCheckoutResponse.url;
    },

  },

  mounted() {
    
    this.cartCount = this.cartCountResponse ?? {}
    this.getCartCount({})

  },

  methods: {
    ...mapActions([
      "getProtectionPlansBundle",
      "getProtectionPlanBundleDetails",
      "getCartCount",
      "getCartDetails",
      "upsertCart",
      "consumerBindCart",
      "cartCheckout",
      "validateCart",
      "removeProtectionItemCart"
    ]),

    getBundleData() {
      this.getProtectionPlansBundle({ 'partner_id': this.selectedProtectionPlan.partner_id, "route_slug": this.selectedProtectionPlan.route_slug });
    },

    removeBundle(data) {
      this.removeProtectionItemCart({
        "bundle_ids": data.bundle_ids,
        "plan_ids": data.plan_ids,
      })
    },

    openNRGModel() {
      const { Modal } = require('bootstrap');
      const modalEl = this.$refs.NRGModal;
      this.modal = Modal.getInstance(modalEl);
      if (!this.modal) {
        this.modal = new Modal(modalEl, {
          backdrop: 'static',
          keyboard: true
        });
        this.adjustNRGModalHeight();
      }
      // Add event listeners for show/hide
      modalEl.addEventListener('show.bs.modal', () => {
        document.documentElement.style.overflow = 'hidden'; // Target HTML element
        if (window.innerWidth >= 992) {
          document.documentElement.style.paddingRight = '15px';
        } else {
          document.documentElement.style.paddingRight = '0px';
        }
        window.removeEventListener('resize', this.adjustNRGModalHeight);
        window.removeEventListener('orientationchange', this.adjustNRGModalHeight);
      });

      modalEl.addEventListener('hidden.bs.modal', () => {
        document.documentElement.style.overflow = ''; // Reset HTML element
        document.documentElement.style.paddingRight = '0px';
      });
      window.addEventListener('resize', this.adjustNRGModalHeight);
      window.addEventListener('orientationchange', this.adjustNRGModalHeight);
      this.modal.show();
    },
    adjustPlanModalHeight() {
      const modalContent = this.$refs.protectionPlanDetailModal?.querySelector('.responsiveOreitationHeightAdjust');
      if (modalContent) {
        const vh = window.innerHeight;
        const vw = window.innerWidth;
        let maxHeight;
        if (vw < 400) {
          maxHeight = vh * 0.5 - 40;
        } else if (vw < 768) {
          maxHeight = vh * 0.4 - 40;
        } else if (vw < 1024) {
          maxHeight = vh * 0.4 - 30;
        } else {
          maxHeight = vh * 0.6 - 40;
        }
        modalContent.style.maxHeight = `${maxHeight}px`;
        modalContent.style.overflowY = 'auto';
      }
    },
    adjustCartModalHeight() {
      const modalContent = this.$refs.cartModal?.querySelector('.responsiveOreitationCartHeightAdjust');
      if (modalContent) {
        const vh = window.innerHeight;
        const vw = window.innerWidth;
        let maxHeight;
        if (vw < 400) {
          maxHeight = vh * 0.4 - 40;
        } else if (vw < 768) {
          maxHeight = vh * 0.5 - 40;
        } else if (vw < 1024) {
          maxHeight = vh * 0.5 - 30;
        } else {
          maxHeight = vh * 0.4 - 40;
        }
        modalContent.style.maxHeight = `${maxHeight}px`;
        modalContent.style.overflowY = 'auto';
      }
    },
    adjustNRGModalHeight() {
      const modalContent = this.$refs.cartModal?.querySelector('.responsiveOreitationNRGHeightAdjust');
      if (modalContent) {
        const vh = window.innerHeight;
        const vw = window.innerWidth;
        let maxHeight;
        if (vw < 400) {
          maxHeight = vh * 0.4 - 40;
        } else if (vw < 768) {
          maxHeight = vh * 0.5 - 40;
        } else if (vw < 1024) {
          maxHeight = vh * 0.5 - 30;
        } else {
          maxHeight = vh * 0.4 - 40;
        }
        modalContent.style.maxHeight = `${maxHeight}px`;
        modalContent.style.overflowY = 'auto';
      }
    },
    cartModal() {
      if (this.cartCount?.items_count > 0) {
        //this.getCartDetails({})
        this.$refs.protectionCartRef.openCartModal()

      }
     
    },
    onCartModalClose() {
      this.getBundleData();
    },
    nextClicked() {
      this.isFromNRGModal = true
      this.getCartCount({})
    },

    planModal(plan) {
      this.selectedPlan = plan
      //  this.$refs.protectionCarDetailtRef.openCartModal(plan)
      this.getDetails(plan)
    },

    getDetails(plan) {
      //   this.$refs.protectionCarDetailtRef.getDetails(this.selectedPlan)
      this.getProtectionPlanBundleDetails({
        id: plan.id
      })

    },
    updateCart(option, plan, type = 'bundle', action = 'update') {
      if (type == 'nrg') {
        this.nrgModal(true)
      }
      else {
        this.selectedPlan = plan
        this.selectedType = type
        if (option == "cartUpdate") {
          this.isCartUpdate = true
        } else {
          this.isCartUpdate = false
        }
         
        if (option == 'decrement' || option == 'remove') {

          if (type == 'bundle') {
            this.upsertCart({
              "bundle_id": plan.id,
              "quantity": plan.quantity,
              "partner_id": plan.partner_id? plan.partner_id : this.selectedProtectionPlan.partner_id
            })
          }
          else {
            this.upsertCart({
              "plan_id": plan.id,
              "quantity": plan.quantity,
              "partner_id": plan.partner_id? plan.partner_id : this.selectedProtectionPlan.partner_id

            })
          }

        }
        else {

          if (type == 'bundle') {
            this.validateCart({
              "bundle_id": plan.id,
              "quantity": plan.quantity,
             "partner_id": plan.partner_id? plan.partner_id : this.selectedProtectionPlan.partner_id

            })
          }
          else {
            this.validateCart({
              "plan_id": plan.id,
              "quantity": plan.quantity,
              "partner_id": plan.partner_id? plan.partner_id : this.selectedProtectionPlan.partner_id

            })
          }
        }
      }

    },

    updateCounter(option) {
      let quantity = JSON.parse(JSON.stringify(this.protectionPlanDetails.quantity))
      if (option == "increment") {
        quantity++
      } else if (option == "decrement" || option == "remove") {
        if (quantity > 1) {
          quantity--
        } else {
          quantity = 0
        }
      } else {
        quantity = 0
      }
      this.updateCart(option, {
        id: this.protectionPlanDetails.id,
        quantity: quantity,
        type: 'bundle'
      })


      // var quantity = 0
      // if (option == "increment") {
      //   quantity = 1
      // }

      // this.updateCart(option, {
      //   id: this.protectionPlanDetails.id,
      //   quantity: quantity,
      //   type: 'bundle'
      // })
    },

    submitClicked(data) {
      this.consumerBindCart(data)
    },

    nrgModal(isOpenFromCart) {
      if (this.cartCountResponse?.checkout_type == 'internal') {
        this.$router.push({
          name: 'partnerCheckout'
        })
      } else {
        if (this.modal) {
          this.modal.hide()
        }
        if (!isOpenFromCart) {
          if (this.cartModal == null || (this.cartCount && this.cartCount.items_count > 0)) {
            this.$refs.createQuoteRef.showModal();
          }
        } else {
          setTimeout(() => {
            if (this.cartModal == null || (this.cartCount && this.cartCount.items_count > 0)) {
              this.$refs.createQuoteRef.showModal();
            }
          }, 500);
        }
      }
    },
    shareModal() {
      this.$refs.openSharePlanModal.openModal()
    },

    planalreadypurchasedHide() {
      const modalEl = this.$refs.planalreadypurchasedmodal;
      if (modalEl) {
        const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
        modal.hide();
      }
    }
  },
};
</script>